import { FC } from "react";
import NeverIcon from "@mui/icons-material/AllInclusive";
import { Typography } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/it";
import "dayjs/locale/en";
import { useTranslation } from "react-i18next";

interface Props {
	date?: string | Dayjs;
	format?: "date" | "time" | "datetime";
	iconSize?: "inherit" | "large" | "medium" | "small";
}

/**
 * DateIndicator renders a date string or a "-" icon.
 *
 * @param date
 * @param format
 * @param iconSize
 * @constructor
 */
const DateIndicator: FC<Props> = ({ date, format = "date", iconSize }) => {
	const { i18n } = useTranslation();

	if (!date) {
		return <NeverIcon fontSize={iconSize} />;
	}

	let localizationFormat = "";
	switch (format) {
		case "date":
			localizationFormat = "LL";
			break;
		case "time":
			localizationFormat = "LT";
			break;
		case "datetime":
			localizationFormat = "lll";
			break;
	}

	dayjs.locale(i18n.language);
	const formattedString = dayjs.isDayjs(date)
		? date.format(localizationFormat)
		: dayjs(date).format(localizationFormat);

	return <Typography>{formattedString}</Typography>;
};

export default DateIndicator;
